module.exports = __webpack_public_path__ + "media/images/common/sp_pic-ba563ae13455dac09499360d1555d2d5.png";